import consumer from "./consumer"

consumer.subscriptions.create({ channel: "MessageChannel" }, {
  received(data) {
    if (notify.permissionLevel() === notify.PERMISSION_GRANTED){
      notify.createNotification(data.title, {body: data.message, icon: data.icon, timeout: 10000})
    }
    InstantMessage.update();
  }
})
